import React, { useContext, useEffect, useState } from "react";
import OwLabel from "../../shared/OwLabel/OwLabel";
import Typeahead from "../../shared/Typeahead/Typeahead";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import systemConst from "../../../services/SystemConst";
import * as _ from "lodash-es";
import IVendorModel from "../../../models/IVendorModel";
import { SocketContext } from "../../../contexts/SocketContext";
import VendorContext from "../../../contexts/VendorContext";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import IPrice_Group from "../../../models/IPrice_Group";
import ICatalog from "../../../models/ICatalog";
import ICatalog_ItemUI from "../../../models/ICatalog_ItemUI";
import IOnGetVendorsDTO from "../../../models/DTO/IOnGetVendorsDTO";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import EndpointsEnum from "../../../models/EndpointsEnum";
import { useAppContextNonNull } from "@contexts/AppContext";

type Props = {
    cartItems: ICatalog_ItemUI[];
    catalogs: ICatalog[];
    setCatalog: (catalog: ICatalog | null) => void;
    setPriceGroup: (priceGroup: IPrice_Group | null) => void;
    setSelectedVendor: (vendor: IVendorModel | null) => void;
};

export const InventoryAccountSelection = (props: Props) => {
    const { userModel, supplierModel, vendorModel, socket } = useAppContextNonNull();

    let showCatalogPriceGroupSelection = true;
    let showCatalogSelection = true;
    let showPriceGroupSelection = true;

    if (userModel?.supplierUserToken) {
        const supplierUserToken = userModel?.supplierUserToken;

        if (supplierUserToken.access_type_id === systemConst.accessTypes.RESTRICTED) {
            if (!_.isNil(supplierUserToken.price_group_id) && !_.isNil(supplierUserToken.catalog_id)) {
                showCatalogPriceGroupSelection = false;
            } else {
                if (!_.isNil(supplierUserToken.price_group_id)) {
                    showPriceGroupSelection = false;
                }

                if (!_.isNil(supplierUserToken.catalog_id)) {
                    showCatalogSelection = false;
                }
            }
        }
    } else if (userModel.vendorUserToken) {
        // TODO - Setup for the vendor users options here.

        if (supplierModel.hide_vendor_price_group_select) {
            showPriceGroupSelection = false;
        }
    }

    const onGetVendors = (data: IOnGetVendorsDTO) => {
        const _foundVendors = data.supplierVendorTokens.map((tokenData) => {
            return tokenData.Vendor!;
        });

        setFoundVendors(_foundVendors);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.VendorsOnGetVendors, fn: onGetVendors }];

    const [clearVendorTypeahead, setClearVendorTypeahead] = useState(false);
    const [foundVendors, setFoundVendors] = useState<IVendorModel[]>([]);
    const [hasCatalogLock, setHasCatalogLock] = useState(false);
    const [hasPriceGroupLock, setHasPriceGroupLock] = useState(false);
    const [lockedCatalogName, setLockedCatalogName] = useState<string | null>("");
    const [lockedPriceGroupName, setLockedPriceGroupName] = useState<string | null>("");
    const [selectedVendor, setSelectedVendor] = useState<IVendorModel | null>(null);
    const [priceGroup, setPriceGroup] = useState<IPrice_Group | null>(null);
    const [catalog, setCatalog] = useState<ICatalog | null>(null);
    const [priceGroups, setPriceGroups] = useState<IPrice_Group[]>([]);
    const [catalogs, setCatalogs] = useState<ICatalog[]>(props.catalogs);

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    useEffect(() => {
        setCatalogs(props.catalogs);
    }, [props.catalogs]);

    const findVendorsByName = async (typeahead: string) => {
        const encodedTypeahead = encodeURIComponent(typeahead);

        const payload = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            queryString: `name=${encodedTypeahead}`,
        };

        socket.emit(EndpointsEnum.VendorsGetVendors, payload);
    };

    const selectedVendorFn = (vendor: IVendorModel) => {
        let _hasCatalogLock = false;
        let _hasPriceGroupLock = false;
        let _lockedCatalogName: any = null;
        let _lockedPriceGroupName: any = null;

        if (!_.isNil(vendor.lock_catalog_id)) {
            _hasCatalogLock = true;
            _lockedCatalogName = _.get(vendor, "Catalog.name", "");

            if (vendor.Catalog) {
                props.setCatalog(vendor.Catalog);
            }

            const e = {
                target: {
                    type: "select",
                    value: vendor.lock_catalog_id,
                    name: "catalog",
                },
            };

            handleChange(e);
        } else {
            if (userModel?.isSupplierUser && !_.isNil(userModel?.supplierUserToken?.catalog_id)) {
                _hasCatalogLock = true;
                _lockedCatalogName = _.get(userModel.supplierUserToken, "Catalog.name", "");

                if (userModel.supplierUserToken?.Catalog) {
                    props.setCatalog(userModel.supplierUserToken.Catalog);
                }
            }
        }

        if (!_.isNil(vendor.price_group_id)) {
            _hasPriceGroupLock = true;
            _lockedPriceGroupName = _.get(vendor, "Price_Group.value", "");

            if (vendor.Price_Group) {
                props.setPriceGroup(vendor.Price_Group);
            }
        } else {
            if (userModel?.isSupplierUser && !_.isNil(userModel.supplierUserToken?.price_group_id)) {
                _hasPriceGroupLock = true;
                _lockedPriceGroupName = _.get(userModel.supplierUserToken, "Price_Group.value", "");

                if (userModel.supplierUserToken?.Price_Group) {
                    props.setPriceGroup(userModel.supplierUserToken.Price_Group);
                }
            }
        }

        let is_sample: boolean | undefined;

        if (supplierModel.has_sample_orders) {
            is_sample = false;

            if (vendor.is_sample_account) {
                is_sample = true;
            }
        }

        setFoundVendors([]);
        setSelectedVendor(vendor);
        setHasCatalogLock(_hasCatalogLock);
        setHasPriceGroupLock(_hasPriceGroupLock);
        setLockedCatalogName(_lockedCatalogName);
        setLockedPriceGroupName(_lockedPriceGroupName);
        props.setSelectedVendor(vendor);
    };

    const clearTypeaheadCallback = () => {
        setSelectedVendor(null);
        setHasCatalogLock(false);
        setHasPriceGroupLock(false);
        setLockedCatalogName("");
        setLockedPriceGroupName("");
        setCatalog(null);
        setPriceGroups([]);
        props.setSelectedVendor(null);
        props.setCatalog(null);
        props.setPriceGroup(null);
    };

    const handleChange = (e: any) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

        switch (e.target.name) {
            case "catalog":
                if (_.isNil(value) || !value.length) {
                    setCatalog(null);
                    setPriceGroups([]);
                } else {
                    const foundCatalog = props.catalogs.find((_catalog: ICatalog) => {
                        return _catalog.id === Number(value);
                    });

                    if (foundCatalog) {
                        setCatalog(foundCatalog);
                        setPriceGroups(foundCatalog.Price_Groups || []);
                        props.setCatalog(foundCatalog);
                    }
                }

                break;
            case "price_group":
                if (_.isNil(value) || !value.length) {
                    setPriceGroup(null);
                } else {
                    const foundPriceGroup = priceGroups.find((_priceGroup: IPrice_Group) => {
                        return _priceGroup.id === Number(value);
                    });

                    if (foundPriceGroup) {
                        setPriceGroup(foundPriceGroup);
                        props.setPriceGroup(foundPriceGroup);
                    }
                }
                break;
        }
    };

    return (
        <div className={"InventoryAccountSelection"}>
            <div className={"row mb-2"}>
                <div className="col-12 col-sm-6 col-md-3">
                    <OwLabel
                        isBold={true}
                        title={"vendor"}
                        supplierModel={supplierModel}
                        isSupplierVendorOverride={true}
                        showIsReqAsterik={true}
                    />
                    <div className="position-relative">
                        <div className={userModel?.isSupplierUser ? "" : "d-none"}>
                            <Typeahead
                                className=""
                                clearTypeahead={clearVendorTypeahead}
                                clearTypeaheadCallback={() => {
                                    clearTypeaheadCallback();
                                }}
                                typeaheadItems={foundVendors}
                                titleProp="name"
                                subTitleProp=""
                                maxResults={50}
                                scrollableList={true}
                                isRequired={true}
                                placeholder="Search"
                                selectedItem={selectedVendor}
                                isSelectableFn={() => {
                                    return true;
                                }}
                                selectedItemFn={selectedVendorFn}
                                typeaheadApiFn={findVendorsByName}
                            />
                        </div>
                        <div className={userModel?.isSupplierUser ? "d-none" : ""}>{vendorModel?.name}</div>
                    </div>
                </div>

                {selectedVendor ? (
                    <>
                        <div className={showCatalogPriceGroupSelection ? "col-12 col-sm-6 col-md-3" : "d-none"}>
                            <div className={showCatalogSelection ? "mb-4 mb-md-0" : "d-none"}>
                                <OwLabel isBold={true} title={"catalog"} showIsReqAsterik={true} />
                                <div className={hasCatalogLock ? "d-none" : ""}>
                                    <OwSelectOption
                                        options={catalogs}
                                        valueProp={"id"}
                                        titleProp={"name"}
                                        fn={handleChange}
                                        name={"catalog"}
                                        isRequired={true}
                                        selectedOption={catalog}
                                        selectedOptionProp={"id"}
                                        isDisabled={!!props.cartItems.length}
                                        emitOnLoad={true}
                                        emitTarget={true}
                                        showBlankFirst={true}
                                    />

                                    {/*{getRequiredCatalogCategories()}*/}
                                </div>
                                <div className={hasCatalogLock ? "" : "d-none"}>{lockedCatalogName}</div>
                            </div>
                        </div>

                        <div className={showPriceGroupSelection ? "col-12 col-sm-6 col-md-3" : "d-none"}>
                            <OwLabel isBold={true} title={"price_group"} showIsReqAsterik={true} />
                            <div className={hasPriceGroupLock ? "d-none" : ""}>
                                <OwSelectOption
                                    options={priceGroups}
                                    selectedOption={priceGroup}
                                    selectedOptionProp={"id"}
                                    valueProp={"id"}
                                    titleProp={"value"}
                                    fn={handleChange}
                                    name={"price_group"}
                                    isRequired={true}
                                    showBlankFirst={true}
                                />
                            </div>
                            <div className={hasPriceGroupLock ? "" : "d-none"}>{lockedPriceGroupName}</div>
                        </div>
                    </>
                ) : null}
            </div>
        </div>
    );
};
